import LoansDaytodayOperations from './views/index.c';

export default LoansDaytodayOperations;
